module.exports = __webpack_public_path__ + "img/blog12.0f401d24.jpeg";